import React, {Component} from 'react';
import {
  HashRouter as Router,
  Switch,
  Route,
  Link
} from "react-router-dom";
import '../classes/I18nHelper';
import { Trans } from 'react-i18next';
import FilterColumn from "../components/FilterColumn";
import SearchFilter from "../components/SearchFilter";
import SearchResults from "../components/SearchResults";
import VenueRepository from "../classes/VenueRepository"
import SearchPaging from "../components/SearchPaging";
import SearchTabs from "../components/SearchTabs";
import SearchResultsMap from "../components/SearchResultsMap";
import FilterHelper from "../classes/FilterHelper";
import 'core-js/fn/array/for-each';
import 'core-js/fn/array/find';
import 'react-app-polyfill/ie11';
import Loader from "../components/Loader";
import {Waypoint} from "react-waypoint";
import Icon from "../components/Icon";

class VenueFinder extends Component {

  constructor(props) {
    super(props);
    this.filterHelper = new FilterHelper();
    this.state = {searchresults: [], form: this.filterHelper.getInitialFormValues(), loading: false, filterObjects: [], load_more: false};
    this.venueRepository = new VenueRepository();

    this.forceResetSlider = false;

    this.onFilter = this.onFilter.bind(this);
    this.startLoading = this.startLoading.bind(this);
    this.endLoading = this.endLoading.bind(this);
    this.removeFilter = this.removeFilter.bind(this);
    this.removeAllFilters = this.removeAllFilters.bind(this);
    this.removePaging = this.removePaging.bind(this);
    this.addPaging = this.addPaging.bind(this);

  }

  componentDidMount() {
    this.startLoading();
    this.venueRepository.getAllVenues().then((results) => {
      this.setState({searchresults: results});
      this.endLoading();
    });
  }

  removePaging() {
    this.startLoading();
    this.venueRepository.callFilterUrl(true).then((results) => {
      this.setState({searchresults: results, filterObjects: this.venueRepository.filterObjects});
      this.endLoading();
    });
  }

  addPaging() {
    this.startLoading();
    this.venueRepository.callFilterUrl().then((results) => {
      this.setState({searchresults: results, filterObjects: this.venueRepository.filterObjects});
      this.endLoading();
    });
  }

  removeFilter(filterName, filterValue) {
    let temp_form = this.state.form;
    let update_filters = false;

    if (filterName === 'field_capacity') {
      temp_form.field_capacity = {};
      /*      temp_form.field_capacity.min = 0;
            temp_form.field_capacity.max = {};*/
      update_filters = true;
    }else if (temp_form[filterName].indexOf(filterValue) !== -1) {
      delete temp_form[filterName][temp_form[filterName].indexOf(filterValue)];
      update_filters = true;
    }

    if (update_filters) {
      this.setState({form: temp_form});
      this.updateAfterFiltering(temp_form);
    }

  }

  removeAllFilters() {
    this.setState({form: this.filterHelper.getInitialFormValues()});
    let temp_form = this.filterHelper.getInitialFormValues();
    this.updateAfterFiltering(temp_form);
  }

  startLoading(load_more) {
    if (typeof load_more === 'undefined') {
      load_more = false;
    }
    this.setState({loading: true, load_more});
  }

  endLoading(load_more) {
    if (typeof load_more === 'undefined') {
      load_more = false;
    }
    this.setState({loading: false, load_more});
  }

  /*
    Used for paging purposes (maybe more?... if so add)
   */
  callApiUrl(api_url) {
    this.startLoading(true);
    this.venueRepository.callUrl(api_url).then((results) => {
      let new_results = this.state.searchresults.concat(results);
      if (results.paging) {
        new_results.paging = results.paging;
      }
      this.setState({searchresults: new_results});
      this.endLoading(true);
    });
  }

  /*
      toDo: rework logic intro helper
   */
  onFilter(keyValues, test){
    this.startLoading();


    let temp_form = this.state.form;

    if (keyValues) {
      if (keyValues.name === 'field_search') {
        temp_form[keyValues.name] = keyValues.value;
      }
      else if (keyValues.name === 'field_capacity') {
        temp_form[keyValues.name] = {};
        temp_form[keyValues.name].min = keyValues.minValue;
        temp_form[keyValues.name].max = keyValues.maxValue;
        this.setState({form: temp_form});
      } else {
        if (Array.isArray(this.state.form[keyValues.name])) {
          if (temp_form[keyValues.name].indexOf(keyValues.value) === -1) {
            temp_form[keyValues.name].push(keyValues.value);
            this.setState({form: temp_form});
          } else {
            temp_form[keyValues.name].splice( this.state.form[keyValues.name].indexOf(keyValues.value), 1 );
            this.setState({form: temp_form});
          }
        }
      }
    }

    this.venueRepository.addFilterLabels(keyValues);
    this.updateAfterFiltering(temp_form);

  }

  updateAfterFiltering(temp_form) {
    // Hack to save labels for tag cloud
    if (typeof this.state.searchresults.paging === 'undefined') {
      return;
    }
    this.venueRepository.updateFilters(temp_form, this.state.searchresults.paging.self.href);
    this.venueRepository.applyFilters();


    // Filter resets paging, we should reset to default URL
    // toDo: Define this in another way
    this.venueRepository.callFilterUrl().then((results) => {
      this.setState({searchresults: results, filterObjects: this.venueRepository.filterObjects});
      this.endLoading();
    });
  }

  render() {
    console.log('RENDER ROOT!');
    let searchResultsMap = null;
    let searchResult = null;
    if (this.state.loading && !this.state.load_more) {
      searchResultsMap = (<Loader/>);
      searchResult = (<Loader/>);
    } else if(this.state.loading && this.state.load_more){
      searchResult = (
        <React.Fragment>
          <SearchResults addPaging={this.addPaging} results={this.state.searchresults}/>
          {this.state.searchresults.paging && <Loader/>}
        </React.Fragment>
      )
    } else {
      searchResultsMap = (
        <div className="map-wrapper">
          <SearchResultsMap removePaging={this.removePaging} results={this.state.searchresults}/>
        </div>);
      searchResult = (
        <React.Fragment>
          <SearchResults addPaging={this.addPaging} results={this.state.searchresults}/>
          {this.state.searchresults.paging && <SearchPaging callApi={(url) => {this.callApiUrl(url.href)}}  paging={this.state.searchresults.paging}/> }
          {this.state.searchresults.paging && this.state.searchresults.paging.next && <Waypoint onEnter={() => {
            this.callApiUrl(this.state.searchresults.paging.next.href)
          }}/>}
        </React.Fragment>
      )
    }


    return (
      <React.Fragment>
        <Router>
          <h1 className="venue-finder__heading">
            <Trans i18nKey="venue_finder.page_title">Find your venue</Trans>
          </h1>
          <div className="venue-finder">
            <form>
              <div className="venue-finder__inner">
                <div className="venue-finder__filter">
                  <FilterColumn filterLabels={this.venueRepository.filterLabels} removeAllFilters={() => this.removeAllFilters()} removeFilter={(filterName, filterValue) => this.removeFilter(filterName, filterValue)} filterObjects={this.state.filterObjects} form={this.state.form} onFilter={this.onFilter} />
                </div>
                <div className="venue-finder__results">
                  <div className="venue-finder-views">
                    <div className="venue-finder-views__search">
                      <SearchFilter onFilter={this.onFilter}/>
                    </div>
                    <div className="venue-finder-views__filters">
                      <button type="button" className="button button--primary js-filter-open" aria-expanded="false">
                        <span className="button__icon button__icon--filter button__icon--standalone">
                          <Icon iconId="filter" />
                        </span>
                        <span className="button__text">
                          <Trans i18nKey="venue_finder.filters">Filters</Trans>
                        </span>
                      </button>
                    </div>
                    <div className="venue-finder-views__view">
                      <SearchTabs/>
                    </div>
                  </div>
                  <Switch>
                    <Route path="/map">
                      {searchResultsMap}
                    </Route>
                    <Route path="/">
                      {searchResult}
                    </Route>
                  </Switch>
                </div>
              </div>
            </form>
          </div>
        </Router>
      </React.Fragment>
    );
  }
}

export default VenueFinder;
